import { apiGet } from 'App/Dataman';
import { WIMS_PULSE_PATHS } from './path';

export function getStatus() {
  return apiGet(WIMS_PULSE_PATHS.status);
}

export default {
  getStatus,
};
